var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediologyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192mm",
    height: "27mm",
    viewBox: "0 0 192 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.42147,
    y: -0.84294,
    width: 297.56,
    height: 210.74,
    fill: "#fff",
    strokeWidth: 0.26458
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f9f9f9",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.283 24.304-3.1115-20.743h-5.6896l-4.9191 11.29-4.8895-11.29h-5.7192l-3.1411 20.743h5.8081l1.6002-11.913 5.4822 11.972h1.6891l5.5118-12.001 1.6002 11.942z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.316 19.355v-3.1115h7.3448v-4.6821h-7.3448v-3.0522h8.1153v-4.9488h-13.805v20.743h14.072v-4.9488z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.403 3.5606h-8.3862v20.743h8.3862c6.2823 0 10.727-4.3265 10.727-10.372 0-6.0748-4.445-10.372-10.727-10.372zm-0.2667 15.528h-2.3707v-10.283h2.3707c3.0819 0 5.1266 2.0447 5.1266 5.1266 0 3.0522-2.0447 5.1562-5.1266 5.1562z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m74.093 24.304h5.8081v-20.743h-5.8081z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.244 24.837c6.6675 0 11.409-4.5339 11.409-10.875 0-6.3712-4.7413-10.905-11.409-10.905-6.6675 0-11.409 4.5635-11.409 10.905 0 6.3119 4.7413 10.875 11.409 10.875zm0-5.3044c-3.1411 0-5.4822-2.3707-5.4822-5.5711 0-3.23 2.341-5.6007 5.4822-5.6007 3.1708 0 5.4525 2.341 5.4525 5.6007 0 3.23-2.2818 5.5711-5.4525 5.5711z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.36 19.088v-15.528h-5.8081v20.743h13.187v-5.2155z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.04 24.837c6.6675 0 11.409-4.5339 11.409-10.875 0-6.3712-4.7413-10.905-11.409-10.905s-11.409 4.5635-11.409 10.905c0 6.3119 4.7413 10.875 11.409 10.875zm0-5.3044c-3.1411 0-5.4822-2.3707-5.4822-5.5711 0-3.23 2.341-5.6007 5.4822-5.6007 3.1708 0 5.4525 2.341 5.4525 5.6007 0 3.23-2.2818 5.5711-5.4525 5.5711z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.9 13.221v3.6153h5.1562c-0.65193 1.6002-2.5188 2.667-4.7117 2.667-3.1411 0-5.1858-2.2521-5.1858-5.5414 0-3.3189 2.0743-5.5711 5.1858-5.5711 2.104 0 3.9709 1.1261 4.7117 2.8744h6.0156c-0.889-4.8006-5.334-8.2084-10.787-8.2084-6.3712 0-10.994 4.5932-10.994 10.905 0 6.3119 4.7117 10.875 11.053 10.875 6.4897 0 10.935-4.8302 10.935-11.616z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.04 3.5606h-6.3119l-3.7931 7.4972-3.7931-7.4972h-6.3415l7.2009 12.624v8.1195h5.8081v-8.0899z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediologyLogo);
export default __webpack_public_path__ + "static/media/Mediology_logo.5c9f7296499c0a5f8fd2d68462295bd8.svg";
export { ForwardRef as ReactComponent };